import { useCallback, useEffect, useState } from 'react'
import { REQUEST_REFINEMENT_EVENT } from '@/features/refinement/refinementEvents'

export function useAiAskBarRefinement({ composerEditorRef, setComposerPlainText }) {
  const [refinement, setRefinement] = useState(null)

  const clearRefinement = useCallback(() => setRefinement(null), [])

  useEffect(() => {
    const handleRefinement = (event) => {
      const text = String(event.detail?.text ?? '').trim()
      if (!text) return

      setRefinement({
        selectedText: text,
        source: event.detail?.source === 'artifact' ? 'artifact' : 'assistant_response',
        sourceResponseText: event.detail?.sourceResponseText ? String(event.detail.sourceResponseText) : undefined,
        artifactId: event.detail?.artifactId ? String(event.detail.artifactId) : undefined,
        artifactName: event.detail?.artifactName ? String(event.detail.artifactName) : undefined,
        artifactKind: event.detail?.artifactKind ? String(event.detail.artifactKind) : undefined,
      })
      setComposerPlainText('')
      window.requestAnimationFrame(() => {
        composerEditorRef.current?.clearDocument()
        composerEditorRef.current?.focusEnd()
      })
    }

    window.addEventListener(REQUEST_REFINEMENT_EVENT, handleRefinement)
    return () => window.removeEventListener(REQUEST_REFINEMENT_EVENT, handleRefinement)
  }, [composerEditorRef, setComposerPlainText])

  return { refinement, refinementText: refinement?.selectedText ?? '', clearRefinement }
}
